





























import Vue from "vue";
export default Vue.extend({
  props: {
    email: {
      type: String,
      required: true,
    },
    valid: {
      type: Boolean,
      default: false,
    },
    fix: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const onRemove = () => emit("remove");
    const onFix = () => emit("fix");
    return {
      onRemove,
      onFix,
    };
  },
});
